import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store.js';
import { BrowserRouter } from 'react-router-dom';
import './style/index.css';
import './style/variables.css';
import { PersistGate } from 'redux-persist/integration/react';
import WebSocketProvider from './components/WebSocketProvider/WebSocketProvider.jsx';
import { ThemeProvider } from 'styled-components';
import './helpers/hideErrors.js'
import {
  MeetingProvider,
  lightTheme,
  GlobalStyles,
} from 'amazon-chime-sdk-component-library-react';
window.global = window;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <WebSocketProvider>
            <ThemeProvider theme={lightTheme}>
              <GlobalStyles />
              <MeetingProvider>
                <App />
              </MeetingProvider>
            </ThemeProvider>
          </WebSocketProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
